<template>
  <div class="card hangupcause-statistics">
    <div class="card-body">
      <h6 class="chart-title">Distribuição por status de chamadas</h6>
      <div class="donut-center">
        <div class="donut-square">
          <canvas ref="canvas" />
        </div>
      </div>
      <div class="donut-legend">
        <button
          v-for="item in legend"
          :key="item.label"
          type="button"
          class="donut-legend-item"
          :class="{ 'donut-legend-item--off': !item.active }"
          :aria-pressed="item.active"
          @click="$emit('toggle-status', item.label)">
          <span class="donut-legend-dot" :style="{ backgroundColor: item.color }" />
          <span class="donut-legend-label">{{ item.label }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'HangupCauseDonut',
  props: {
    // { labels: [...], hangups: { label: count } }
    donutData: { type: Object, default: () => ({ labels: [], hangups: {} }) },
    // [{ label, color, active }] — calculado no container, compartilhado com a tabela.
    legend: { type: Array, default: () => [] }
  },
  watch: {
    donutData: {
      deep: true,
      handler () {
        this.renderChart()
      }
    }
  },
  mounted () {
    this.chart = null
    this.renderChart()
  },
  beforeDestroy () {
    if (this.chart) this.chart.destroy()
  },
  methods: {
    colors () {
      return this.legend.map(item => item.color)
    },
    renderChart () {
      const labels = (this.donutData && this.donutData.labels) || []
      const hangups = (this.donutData && this.donutData.hangups) || {}
      const data = Object.values(hangups)
      const backgroundColor = this.colors()
      if (!this.chart) {
        this.chart = new Chart(this.$refs.canvas, {
          type: 'doughnut',
          data: {
            labels: labels,
            datasets: [{ data: data, backgroundColor: backgroundColor }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            onClick: (event, els) => this.onSliceClick(els),
            onHover: (event, els) => {
              event.target.style.cursor = els.length > 0 ? 'pointer' : 'default'
            },
            title: { display: false },
            legend: { display: false },
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  let label = data.labels[tooltipItem.index] || ''
                  if (label) {
                    if (data.datasets && data.datasets[tooltipItem.datasetIndex].data) {
                      const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                      if (value) {
                        const donutTotal = data.datasets[tooltipItem.datasetIndex].data.reduce((a, b) => a + b, 0)
                        const valuePerc = donutTotal > 0 ? Math.round((value / donutTotal) * 100 * 100) / 100 : 0
                        label += ` - ${value} (${valuePerc} %)`
                      }
                    }
                  }
                  return label
                }
              }
            }
          }
        })
      } else {
        this.chart.data.labels = labels
        this.chart.data.datasets = [{ data: data, backgroundColor: backgroundColor }]
        this.chart.update()
      }
    },
    onSliceClick (els) {
      if (!els || els.length === 0) return
      const labels = (this.donutData && this.donutData.labels) || []
      this.$emit('toggle-status', labels[els[0]._index])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/HangupCauseDonut.vue